module.exports = __webpack_public_path__ + "static/media/unnamed (3).868c5f83.webp";